import React, { SVGProps } from 'react';

export const CaretDown = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="17"
    height="16"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g>
      <path
        d="M8.02951 11.0002L3.35901 6.30021L4.20951 5.45071L8.02951 9.26971L11.8495 5.44971L12.7 6.30021L8.02951 11.0002Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
